import {useDispatch, useSelector} from "react-redux"
import {useNavigate} from "react-router-dom"

import {
  resetFilterSideBar,
  updateNodeFuctionalText,
  updateNodeFunctionalLevel,
  updateSearchText,
  updateSearchType,
} from "redux/actions"

export default function useSearchCategoryChange({onClose} = {}) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const isUserLoggedIn = useSelector(({user}) => user.isUserLoggedIn)

  const handleChangeSelectedOption = optionValue => {
    if (!isUserLoggedIn && optionValue === "list-items") {
      navigate(`/login`)
    } else {
      onClose?.()
      dispatch(updateSearchType(optionValue))
      dispatch(updateNodeFuctionalText(""))
      dispatch(updateNodeFunctionalLevel(""))
      if (optionValue === "products") {
        navigate(`/search/${optionValue}/`)
      } else if (optionValue === "coupons") {
        navigate(`/coupons`)
      }else {
        navigate(`/departments/${optionValue}`)
      }
    }
  }

  return handleChangeSelectedOption
}
